import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'semantic-ui-css/semantic.min.css';
import { Amplify } from 'aws-amplify';
import amplifyconfig from './aws-exports';
Amplify.configure(amplifyconfig);
import App from './App';
import {unregister} from './registerServiceWorker';
import {createRoot} from "react-dom/client";


const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
        <App />
);
unregister();
